import { getApiBaseUrl } from '../../config/runtimeConfig';
import { sessionFetch } from '../../services/session';
async function request(path = '', options = {}) {
 let response;
 try { response = await sessionFetch(`${getApiBaseUrl()}/units${path}`, { credentials: 'include', ...options, headers: { Accept: 'application/json', ...options.headers }, signal: AbortSignal.timeout(20000) }); }
 catch (error) { throw new Error('Unable to connect. Please try again.'); }
 const data = await response.json().catch(() => null);
 if (!response.ok) throw Object.assign(new Error(data?.message || 'Unable to complete the unit request.'), { status: response.status });
 return data;
}
let pending;
export function getUnits() {
 if (!pending) pending = request().then(data => data.units || []).finally(() => { pending = null; });
 return pending;
}
export async function getUnit(id) { return (await request(`/${id}`)).unit; }
const payload = (method, data) => ({ method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export async function createUnit(data) { return (await request('', payload('POST', data))).unit; }
export async function updateUnit(id, data) { return (await request(`/${id}`, payload('PUT', data))).unit; }
export function deleteUnit(id) { return request(`/${id}`, { method: 'DELETE' }); }
